module.exports = __webpack_public_path__ + "norfolk-island.svg?cd496e08fb51d3c65873d68dfeb2fd1e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/norfolk-island.svg
// module id = 251
// module chunks = 10